import { render, staticRenderFns } from "./TemaEditar.vue?vue&type=template&id=1505490a&"
import script from "./TemaEditar.vue?vue&type=script&lang=js&"
export * from "./TemaEditar.vue?vue&type=script&lang=js&"
import style0 from "./TemaEditar.vue?vue&type=style&index=0&id=1505490a&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports